'use strict';

const getScreenBreakpointSize = (width) => {
    const screenWidth = width;

    // breakpoints from css
    const breakpoints = {
        medium: 768,
        larger: 1025
    };

    if (screenWidth < breakpoints.medium) {
        return 'small';
    } else if (screenWidth >= breakpoints.medium && screenWidth < breakpoints.larger) {
        return 'medium';
    } else {
        return 'larger';
    }
};

module.exports = getScreenBreakpointSize;
